import { render, staticRenderFns } from "./DetailsInformationOrg.vue?vue&type=template&id=47842544&"
import script from "./DetailsInformationOrg.vue?vue&type=script&lang=js&"
export * from "./DetailsInformationOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports